import moment from 'moment';

export class Constants {

  // Common "magic" numbers
  public static readonly CONST_INTEGER: number = 2147483647;

  public static readonly CONST_NEGATIVE_INTEGER: number = -2147483647;

  public static readonly CONST_MIN_LENGTH_TEXT: number = 1;

  public static readonly CONST_MIN_LENGTH_RULESET_NAME: number = 3;

  public static readonly CONST_MAX_LENGTH_CRITERIA_SET_NAME: number = 100;

  public static readonly CONST_MAX_LENGTH_NAME: number = 40;

  public static readonly CONST_MAX_LENGTH_TEXT: number = 255;

  public static readonly CONST_MAX_LENGTH_LONGTEXT: number = 4000;

  public static readonly CONST_MAX_LENGTH_REMARK_TEXT: number = 1000;

  public static readonly CONST_MAX_LENGTH_FIELD_PATH: number = 500;

  public static readonly CONST_MAX_LENGTH_NOTES: number = 500;

  public static readonly CONST_LENGTH_ECO_HUB_ID: number = 6;

  public static readonly MIN_YEAR: number = 2000;

  public static readonly MAX_YEAR: number = 2050;

  public static readonly MAX_CLIENT_AGE: number = 120;

  public static readonly CONST_CROPPER_ASPECT_RATIO_4_LOGO: number = 4; // 4 / 1

  public static readonly CONST_CROPPER_ASPECT_RATIO_2_LOGO: number = 2; // 4 / 1

  public static readonly CONST_CROPPER_ASPECT_RATIO_AVATAR: number = 1; // 1 / 1

  public static readonly CONST_CROPPER_RESIZE_TO_WIDTH_LOGO: number = 428;

  public static readonly CONST_CROPPER_RESIZE_TO_HEIGHT_LOGO: number = 128;

  public static readonly CONST_CROPPER_RESIZE_TO_WIDTH_AVATAR_428: number = 428;

  public static readonly CONST_CROPPER_RESIZE_TO_HEIGHT_AVATAR_428: number = 428;

  public static readonly CONST_CROPPER_RESIZE_TO_WIDTH_AVATAR_256: number = 256;

  public static readonly CONST_CROPPER_RESIZE_TO_HEIGHT_AVATAR_256: number = 256;

  public static readonly CONST_CROPPER_RESIZE_TO_WIDTH_AVATAR_512: number = 512;

  public static readonly CONST_CROPPER_MIN_WIDTH_LOGO: number = 54;

  public static readonly CONST_CROPPER_MIN_HEIGHT_LOGO: number = 32;

  public static readonly CONST_CROPPER_MIN_WIDTH_AVATAR: number = 54;

  public static readonly CONST_CROPPER_MIN_HEIGHT_AVATAR: number = 54;

  public static readonly DEFAULT_TOOLTIP_DEBOUNCE_TIME: number = 200;

  public static readonly DEFAULT_DEBOUNCE_TIME: number = 300;

  public static readonly MENU_CLOSE_DELAY: number = 300;

  public static readonly SEARCH_DEBOUNCE_TIME: number = 300;

  public static readonly SEARCH_COMPANY_DEBOUNCE_TIME: number = 400;

  public static readonly ZIP_CITY_DEBOUNCE_TIME: number = 400;

  public static readonly ACTIVE_EXPANSION_PANEL_DEBOUNCE_TIME: number = 600;

  public static readonly MAT_MENU_DEBOUNCE_TIME: number = 400;

  public static readonly GCC_ELEMENT_MODEL_CHANGE_DEBOUNCE_TIME: number = 4000;

  public static readonly DUPLICATE_CALL_TEMPLATE_DEBOUNCE_TIME: number = 600;

  public static readonly ONE_SECOND_IN_MILLISECONDS: number = 1000;

  public static readonly HIGHLIGHT_TIMEOUT: number = 1200;

  public static readonly HIDE_ANIMATION_MS: number = 75;

  public static readonly COUNT_SHOW_ACCOUNTS: number = 16;

  public static readonly MAX_FILE_SIZE_50_MB = 50;

  public static readonly MAX_FILE_SIZE_50_MB_IN_BYTES = Constants.MAX_FILE_SIZE_50_MB * 1024 * 1024;

  public static readonly ATTACHMENT_OBJECT_STATUS: number = 3;

  public static readonly MAX_COUNT_DOCUMENTS: number = 10;

  public static readonly MIN_LENGTH_FOR_SEARCH: number = 3;

  public static readonly MAX_LENGTH_FOR_SEARCH: number = 255;

  public static readonly PAGINATION_INITIAL_PAGE: number = 1;

  public static readonly FETCH_ALL_PAGE_SIZE: number = 1000;

  public static readonly COLLAPSE_ANIMATION_DURATION: number = 200;

  // Date formats
  public static readonly FORMAT_DATE = 'YYYY-MM-DD';

  public static readonly FORMAT_DATE_VALUE_FOR_SERVER = 'DD.MM.YYYY';

  public static readonly FORMAT_DATE_TIME_VALUE_FOR_SERVER = 'YYYY-MM-DDTHH:mm:ss.SSSZ';

  public static readonly FORMAT_TIME_PPL = 'HH:mm';

  public static readonly FORMAT_PIPE_DATE = 'dd.MM.yyyy';

  public static readonly FORMAT_PIPE_YEAR = 'yyyy';

  public static readonly FORMAT_PIPE_DATE_AND_TIME = 'dd.MM.yyyy HH:mm';

  public static readonly FORMAT_PIPE_DATE_AND_TIME_WITH_SECONDS = 'dd.MM.yyyy HH:mm:ss';

  public static readonly DATE_RANGE_DEFAULT_DELAY = moment().subtract(2, 'weeks');

  public static readonly DATE_RANGE_ONE_YEAR_DELAY = moment().subtract(1, 'year');

  public static readonly DATE_RANGE_ONE_DAY_DELAY = moment().subtract(1, 'day');

  public static readonly DATE_SHORT = 'dd.mm.yyyy';

  public static readonly DATE_SHORT_TWO_DIGIT_YEAR = 'dd.mm.yy';

  public static readonly DATE_SHORT_NO_PADDING = 'd.m.yyyy';

  public static readonly DATE_LONG = 'dddd, d. mmmm yyyy';

  public static readonly DATE_MEDIUM = 'd. mmm yyyy';

  public static readonly DATE_MONTH_YEAR = 'mmmm yyyy';

  public static readonly TIME_HM = 'HH:mm';

  public static readonly TIME_HMS = 'HH:mm:ss';

   public static readonly SHORT_DATE_PATTERN = 'dd.MM.yyyy';

   public static readonly LONG_DATE_PATTERN = 'dddd, d. MMMM yyyy';

   public static readonly SHORT_TIME_PATTERN = 'HH:mm';

   public static readonly LONG_TIME_PATTERN = 'HH:mm:ss';

   public static readonly YEAR_MONTH_PATTERN = 'MMMM yyyy';

   public static readonly MONTH_DAY_PATTERN = 'd. MMMM';

  // Others commons constants
  public static readonly CURRENCY_CHF = 'CHF';

  public static readonly CURRENCY_USD = 'USD';

  public static readonly CURRENCY_EUR = 'EUR';

  public static readonly UNICODE_SLASH = 'U+0002F';

  public static readonly UTC = 'UTC';

  public static readonly REGEX_UUID: string = '^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-5][0-9a-fA-F]{3}-[089abAB]'
    + '[0-9a-fA-F]{3}-[0-9a-fA-F]{12}$';

  public static readonly REGEX_NUMBER: RegExp = /^-?\d+(\.\d+)?$/;

  public static readonly EMAIL_PLACEHOLDER: string = 'example@domain.com';

  public static readonly SEARCH_COMPANY_CLIENT_INPUT_ID: string = 'searchCompanyClientForNewCall';

  public static readonly CONST_ANSWER_VALUE_CHANGED = 'ANSWER_VALUE_CHANGED';

  public static readonly CONST_REMARK_VALUE_CHANGED = 'REMARK_VALUE_CHANGED';

  public static readonly CONST_GCC_ELEMENT_CHANGED = 'GCC_ELEMENT_CHANGED';

  public static readonly CONST_GCC_ELEMENT_ATTACHED = 'GCC_ELEMENT_ATTACHED';

  public static readonly CONST_GCC_ELEMENT_DETACHED = 'GCC_ELEMENT_DETACHED';

  public static readonly CONST_TOKEN_TYPE = 'Bearer';

  public static readonly BASE_FONT_FAMILY = 'HK Grotesk, sans-serif';

  public static readonly MATERIAL_SYMBOLS_FONT_SET: string = 'material-symbols-rounded';

  public static readonly ADDED_COLLECTION_FROM: string = 'ADDED_COLLECTION_FROM';

  public static readonly CONST_INSURER_INTERVIEWS_QUESTIONS: string = 'questions';

  public static readonly CONST_INSURER_INTERVIEWS_ANSWERS: string = 'answers';

  public static readonly CONST_INSURER_INTERVIEWS_HISTORY: string = 'history';

  public static readonly CONST_INSURER_INTERVIEWS_CONTACT_PERSONS: string = 'contactPersons';

  public static readonly CONST_FLOWABLE_THEME: string = 'theme-sobrado-flowable';

  public static readonly CONST_FLOWABLE_SBS: string = 'flowable-sbs';

  public static readonly CONST_FLOWABLE_SBS_DATE_PICKER: string = 'flowable-sbs-datepicker';

  public static readonly CLEAR_SESSION_STORAGE: string = 'clear-session-storage';

  public static readonly SESSION_ACTION: string = 'action';

  public static readonly SESSION_REFRESH: string = 'refresh';

  public static readonly SESSION_LOGOUT: string = 'logout';

  public static readonly CHUNK_RELOAD_TIMESTAMP: string = 'chunk-reload-timestamp';

  public static readonly CHUNK_RELOAD_GUARD_MS: number = 30_000;

  public static readonly CHUNK_RELOAD_NEVER: number = 0;

  public static readonly DEPUTY_CONTEXT: string = 'deputy-context';

  // Common symbols
  public static readonly HYPHEN = '-';

  public static readonly HYPHEN_WITH_SPACES = ' - ';

  public static readonly DASH_WITH_SPACES = ' — ';

  public static readonly UNDERSCORE = '_';

  public static readonly APOSTROPHE = '\'';

  public static readonly PERCENT = '%';

  public static readonly PER_MILLE = '‰';

  public static readonly THREE_DOTS = '...';

  public static readonly DOT = '.';

  public static readonly COMMA = ',';

  public static readonly COLON = ':';

  public static readonly SEMICOLON = ';';

  public static readonly SLASH = '/';

  public static readonly BACKSLASH = '\\';

  public static readonly PIPE = '|';

  public static readonly SPACE = ' ';

  public static readonly ARROW_RIGHT = '→';

  public static readonly LETTER_N = 'N';

  public static readonly ASTERISK = '*';

  public static readonly HASHTAG = '#';

  public static readonly QUESTION_MARK = '?';

  public static readonly EXCLAMATION_MARK = '!';

  public static readonly AMPERSAND = '&';

  public static readonly DOUBLE_QUOTE = '"';

  public static readonly HTML_ENTITY_QUOT = '&quot;';

  public static readonly EQUALS = '=';

  public static readonly NEW_LINE = '\n';

  public static readonly PLUS = '+';

  public static readonly LESS_THAN = '<';

  public static readonly GREATER_THAN = '>';

  public static readonly BRACKET_LEFT = '[';

  public static readonly BRACKET_RIGHT = ']';

  public static readonly OPEN_PARENTHESIS = '(';

  public static readonly CLOSE_PARENTHESIS = ')';

  public static readonly ZERO = '0';

  public static readonly DOUBLE_CURLY_BRACKET_LEFT = '{{';

  public static readonly DOUBLE_CURLY_BRACKET_RIGHT = '}}';

  public static BULLET_POINT_WITH_SPACES = ' • ';

  public static readonly COMMA_SPACE = this.COMMA + this.SPACE;

  public static readonly COLON_SPACE = this.COLON + this.SPACE;

  public static readonly SEMICOLON_SPACE = this.SEMICOLON + this.SPACE;

  public static readonly SPACE_CHF = this.SPACE + this.CURRENCY_CHF;

  public static readonly CHF_SPACE = this.CURRENCY_CHF + this.SPACE;

  public static readonly ARROW_RIGHT_SPACES = Constants.SPACE + Constants.ARROW_RIGHT + Constants.SPACE;

  public static readonly SLASH_WITH_SPACES: string = Constants.SPACE + Constants.SLASH + Constants.SPACE;

  public static readonly API_PARAM_KEY = '?key=';

  public static readonly FROM_SNG_PARAM_KEY = 'fromSng=';

  public static readonly SEARCH_PARAM_KEY = '?q=';

  public static readonly BACK_FLW_URL_PARAM_KEY: string = 'backFlwUrl';

}
